import React, { useState } from "react";
import DataTable from "react-data-table-component";

interface viewdatas {
  stateID: number;
  stateName: string;
  isActive: boolean;
  districtID: number;
  districtName: string;
  cityID: number;
  cityName: string;
  locationID: number;
  locationName: string;
  street: string;
  zipcode: number;
  locality: string;
  latitude: string;
  longitude: string;
  tenantID: number;
}

interface LocationViewProps {
  viewData: viewdatas[];
  onEdit: (viewdata: viewdatas) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const LocationView: React.FC<LocationViewProps> = ({
  viewData,
  onEdit,
  onAddClick,
  showAddButton,
}) => {
  const [toggleCleared, setToggleCleared] = useState(false);

  // Handle row selection
  const handleRowSelected = (state: any) => {
    console.log("Selected rows:", state.selectedRows);
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "Location Name",
      selector: (row: viewdatas) => row.locationName,
      sortable: true,
      cell: (row: viewdatas) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.locationName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.locationName}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "State Name",
      selector: (row: viewdatas) => row.stateName,
      sortable: true,
      cell: (row: viewdatas) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>{row.stateName}</span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "District Name",
      selector: (row: viewdatas) => row.districtName,
      sortable: true,
      cell: (row: viewdatas) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>{row.districtName}</span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "City Name",
      selector: (row: viewdatas) => row.cityName,
      sortable: true,
      cell: (row: viewdatas) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>{row.cityName}</span>
        </div>
      ),
      width: "200px",
    },

    // {
    //   name: "Street",
    //   selector: (row: viewdatas) => row.street,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Zipcode",
    //   selector: (row: viewdatas) => row.zipcode,
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "Locality",
    //   selector: (row: viewdatas) => row.locality,
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Latitude",
    //   selector: (row: viewdatas) => row.latitude,
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Longitude",
    //   selector: (row: viewdatas) => row.longitude,
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Status",
      selector: (row: viewdatas) => row.isActive,
      sortable: true,
      cell: (row: viewdatas) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
    },
    {
      name: "",
      cell: (row: viewdatas) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Location"
            onClick={() => onEdit(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="action-button more-button" title="Replace Icon">
            <i className="bi bi-three-dots"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Locations List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Location
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={viewData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No locations found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{
            className: "custom-checkbox",
          }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
        />
      </div>
    </div>
  );
};

export default LocationView;
